import { html, TemplateResult } from 'lit';
import { customElement, state, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { SlotController } from '../../../controllers/slot-controller';
import { MobileController } from '../../../controllers/mobile-controller';

import componentStyles from './se-featured-content-layout.css.lit';

import '../../se-container/se-container';

/**
 * Component for the Featured Content view mode.
 * @element se-featured-content-layout
 *
 * @todo figure out slots and structure, document, build css file, eliminate GHS references, don't implement the slot controller in this component if we can possibly avoid it.
 *
 * @slot eyebrow - The eyebrow slot.
 * @slot title - The title slot.
 * @slot content - The slot to render any other content provided.
 */
@customElement('se-featured-content-layout')
export class SeFeaturedContentLayout extends OutlineElement {
  private mobileController = new MobileController(this);

  static styles = [componentStyles];

  @property({
    type: Boolean,
    reflect: true,
    attribute: 'reverse-layout',
  })
  reverseLayout = false;

  // Implementing the slot controller for slot testing but NOT shadow-shift.
  slots = new SlotController(this, false);

  @state() hasLightSideSlot: boolean;
  @state() hasDarkSideSlot: boolean;

  firstUpdated(): void {
    this.hasLightSideSlot = this.slots.test('light-side');
    this.hasDarkSideSlot = this.slots.test('dark-side');
  }

  render(): TemplateResult {
    const wrapperClasses = {
      'se-featured-content-layout__wrapper': true,
    };
    const isMobile = this.mobileController.isMobile;

    if (!isMobile && this.reverseLayout) {
      return html`
        <section class="${classMap(wrapperClasses)}">
          ${this.hasDarkSideSlot
            ? html`<div class="se-featured-content-layout__dark-side">
                <slot name="dark-side"></slot>
              </div> `
            : null}
          ${this.hasLightSideSlot
            ? html`<div class="se-featured-content-layout__light-side">
                <slot name="light-side"></slot>
              </div> `
            : null}
        </section>
      `;
    } else {
      return html`
        <section class="${classMap(wrapperClasses)}">
          ${this.hasLightSideSlot
            ? html`<div class="se-featured-content-layout__light-side">
                <slot name="light-side"></slot>
              </div> `
            : null}
          ${this.hasDarkSideSlot
            ? html`<div class="se-featured-content-layout__dark-side">
                <slot name="dark-side"></slot>
              </div> `
            : null}
        </section>
      `;
    }
  }
}
